/**
 * Minicart Hero Announcement Bar
 * Injects an announcement bar below "Your Cart" title and above the shipping notice
 */

(function() {
  'use strict';

  /**
   * Get customizer settings from the minicart section
   */
  function getCustomizerSettings() {
    try {
      const customizerData = document.getElementById('minicart-customizer-data');
      if (!customizerData) {
        console.log('Minicart customizer data not found');
        return null;
      }
      
      const data = JSON.parse(customizerData.textContent);
      return data.customizer;
    } catch (error) {
      console.error('Error parsing customizer data:', error);
      return null;
    }
  }

  /**
   * Create and inject the hero announcement bar
   */
  function injectHeroAnnouncementBar() {
    const settings = getCustomizerSettings();
    
    if (!settings) {
      console.log('No customizer settings found');
      return;
    }

    // Check if hero announcement is enabled
    if (!settings.enabled_hero_announcement_bar) {
      console.log('Hero announcement bar is disabled');
      return;
    }

    // Check if message exists
    if (!settings.hero_announcement_message || settings.hero_announcement_message.trim() === '') {
      console.log('No hero announcement message set');
      return;
    }

    // Check if announcement already exists
    if (document.querySelector('.hero-announcement-bar')) {
      console.log('Hero announcement bar already exists');
      return;
    }

    // Find the shipping notice - this is our primary target
    const shippingNotice = document.querySelector('.minicart__shipping-notice, .minicart-shipping-notice, [class*="shipping-notice"]');
    
    if (!shippingNotice) {
      console.log('Could not find shipping notice for announcement bar insertion');
      return;
    }

    // Create the announcement bar element
    const announcementBar = document.createElement('div');
    announcementBar.className = 'hero-announcement-bar';
    announcementBar.innerHTML = settings.hero_announcement_message;
    
    // Apply styles
    announcementBar.style.cssText = `
      background-color: ${settings.bg_hero_announcement_message || '#003452'};
      color: ${settings.color_hero_announcement_message || '#ffffff'};
      padding: 12px 20px;
      text-align: center;
      font-size: 14px;
      line-height: 1.4;
      margin: 0 0 20px 0 !important;
      width: 100%;
      display: block;
      box-sizing: border-box;
    `;

    // Insert BEFORE the shipping notice
    shippingNotice.parentNode.insertBefore(announcementBar, shippingNotice);
    
    console.log('✓ Hero announcement bar injected successfully');
  }

  /**
   * Initialize and watch for minicart updates
   */
  function init() {
    // Function to attempt injection
    const attemptInjection = () => {
      // Remove any existing announcement first to prevent duplicates
      const existing = document.querySelector('.hero-announcement-bar');
      if (existing) {
        existing.remove();
      }
      
      setTimeout(injectHeroAnnouncementBar, 100);
      setTimeout(injectHeroAnnouncementBar, 300);
      setTimeout(injectHeroAnnouncementBar, 600);
    };

    // Watch for minicart opening
    const observeMinicart = () => {
      const minicartContainer = document.querySelector('.minicart__container, #minicart');
      if (!minicartContainer) {
        setTimeout(observeMinicart, 500);
        return;
      }

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            const container = mutation.target;
            if (container.classList.contains('minicart__container--open') || 
                container.classList.contains('is-open')) {
              attemptInjection();
            }
          }
        });
      });

      observer.observe(minicartContainer, {
        attributes: true,
        attributeFilter: ['class']
      });

      // Try injection immediately if minicart is already open
      attemptInjection();
    };

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeMinicart);
    } else {
      observeMinicart();
    }

    // Listen for cart update events
    document.addEventListener('cart:updated', attemptInjection);
    document.addEventListener('cart:refresh', attemptInjection);
    document.addEventListener('minicart:opened', attemptInjection);
  }

  // Start the script
  init();

})();
